var _path, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgFooterDesktop = function SvgFooterDesktop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1440 322",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "footer-desktop_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1440,
    height: 322
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C4C4C4",
    d: "M0 0h1440v322H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#footer-desktop_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0D291C",
    d: "M0-208h1440v530H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.779 286.902-22.374-6.838a87.687 87.687 0 0 1-47.423-47.534l-293.476-708.512a87.685 87.685 0 0 1-.077-67.145l293.74-709.151a87.753 87.753 0 0 1 47.534-47.43l709.588-293.92a87.876 87.876 0 0 1 33.565-6.72 87.735 87.735 0 0 1 33.58 6.65l709.153 293.74a87.843 87.843 0 0 1 47.58 47.47l293.73 709.124a87.88 87.88 0 0 1-.08 67.209L1510.58-54.329a87.619 87.619 0 0 1-47.53 47.424l-709.126 293.73a87.684 87.684 0 0 1-67.145.077",
    fill: "#296379"
  }))));
};

export default SvgFooterDesktop;